import Landing from "./Landing";

const App: React.FC = () => {
  return <Landing />;
};

export default App;
